export const REF_CODE = {
	DATA_CATALOG_GROUP: "REF_DATA_CATALOG_GROUP",
	DATA_CATALOG_GROUP_ITEM: "REF_DATA_CATALOG_GROUP_ITEM",
	DISEASE: "REF_DISEASE",
	HARDWARE: "REF_HARDWARE",
	HARDWARE_REQ_TYPE: "REF_HARDWARE_REQ_TYPE",
	IMAGE_MODALITY: "REF_IMAGE_MODALITY",
	PROJECT_TYPE: "REF_PROJECT_TYPE",
	SOFTWARE: "REF_SOFTWARE",
	TEXTUAL_DATA: "REF_TEXTUAL_DATA",
	FUNDING_SOURCE_TYPE: "REF_FUNDING_SOURCE_TYPE",
};
